import AvailableMeals from "./AvailableMeals";
import MealsSummary from "./MealsSummary";

const Meals = function () {
  return (
    <>
      <MealsSummary />
      <AvailableMeals />
    </>
  );
};

export default Meals;
